<template>
  <div class="user-page full-height">
    <table-con :canReturn='canReturn'>
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">箱号:</div>
            <div class="query-content">{{boxInfo.boxNo}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">用户:</div>
            <div class="query-content">{{boxInfo.userName}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">批次号:</div>
            <div class="query-content">{{boxInfo.containerBatchNo}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">盘点状态:</div>
            <div class="query-content">{{boxInfo.checkStatus | checkStatusFilter}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">NO数:</div>
            <div class="query-content">{{boxInfo.boxGoodsCount}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">盘点通过:</div>
            <div class="query-content">{{boxInfo.passCount}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">盘点未通过:</div>
            <div class="query-content">{{boxInfo.unPassCount}}</div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">未盘点:</div>
            <div class="query-content">{{boxInfo.unCheckCount}}</div>
          </el-col>

        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">订单编号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderNo" size="small" @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">盘点状态:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.checkStatus" placeholder="请选择" size="small" clearable>
                <el-option key="" value="" label="全部"></el-option>
                <el-option key="0" value="0" label="未盘点"></el-option>
                <el-option key="1" value="1" label="盘点通过"></el-option>
                <el-option key="2" value="2" label="盘点未通过"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">装箱开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">装箱结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container">
              <el-button class="form-btn btn-green" @click="transferOrder" :disabled="transferInfo.boxOrderIdList.length <= 0">转移订单</el-button>
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
                  @selection-change="handleOrderSelectionChange"
                  border stripe style="width: 100%" class="box-order-list" height="550">
          <el-table-column type="selection" :selectable="checkboxSelect" width="55"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单编号"></el-table-column>
          <el-table-column prop="createTime" align="center" width="160" label="装箱日" :formatter="formatDate"></el-table-column>
          <el-table-column prop="createUserName" align="center" label="装箱人"></el-table-column>
          <el-table-column prop="orderCreateTime" align="center" width="160" label="下单日" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="boxGoodsCount" align="center" label="装箱数"></el-table-column>
          <el-table-column prop="goodsNameCus" align="center" label="品名" width="260">
            <template v-slot="scope">
              <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="fnsku" align="center" width="190" label="编号"></el-table-column>
          <el-table-column prop="colour" align="center" label="色"></el-table-column>
          <el-table-column prop="goodsSize" align="center" label="尺寸"></el-table-column>
          <el-table-column prop="checkStatus" align="center" label="盘点状态">
            <template v-slot="scope">
              <span v-if="scope.row.isAppendage == '1'" style="color: red">（附属品）</span>
              {{scope.row.checkStatus | checkStatusFilter}}
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination> -->
      </div>
    </table-con>
    <!-- 转移箱子内订单 -->
    <el-dialog title="转移订单" :visible.sync="transferVisiable" width="30%">
      <el-form :model="transferInfo" :rules="rules" ref="boxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item label="目标箱子" prop="targetBoxNo">
          <el-select v-model="transferInfo.toBoxNo" filterable placeholder="请选择" size="small" clearable>
            <el-option v-for="item in boxOptions" :key="item.boxNo" :label="item.boxNo" :value="item.boxNo"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferVisiable = false" class="form-btn btn-gray">取 消</el-button>
        <el-button @click="saveTransfer" :disabled="transferInfo.toBoxNo==''" class="form-btn btn-blue">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import tableCon from '../../views/tableContainer'
export default {
  data () {
    return {
      transferInfo:{
        containerBatchNo:'',
        oldBoxNo:'',
        boxOrderIdList:[],
        toBoxNo:'',
      },
      boxOptions:[],
      transferVisiable:false,
      canReturn: '1',
      pageTitle: '装箱单详情',
      queryInfo: {
        boxNo: '',
        orderNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 999,
        pageNum: 1,
      },
      containerBatchNo: '',
      boxInfo: {
        boxNo: '',
        userName: '',
        containerBatchNo: '',
        checkStatus: '',
        boxGoodsCount: 0,
        passCount: 0,
        unPassCount: 0,
        unCheckCount: 0
      },
      orderList: [],
      total: 0
    };
  },
  components: { tableCon },
  methods: {
    saveTransfer(){
      this.$confirm("确定要转移订单吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post("/box/transferOrder", this.transferInfo);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "转移成功!"
          });
          this.transferInfo.toBoxNo = ''
          this.transferInfo.boxOrderIdList = []
          this.transferVisiable = false
          await this.getContainerCount();
          await this.getContainerList();
        }

      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });

    },
    async transferOrder(){
      const { data: res } = await this.$http.get('box/getBoxListByContainerBatchNo',{params:{containerBatchNo: this.containerBatchNo, boxNo: this.boxInfo.boxNo}});
      this.boxOptions = res.data
      this.transferInfo.containerBatchNo = this.containerBatchNo
      this.transferInfo.oldBoxNo = this.boxInfo.boxNo
      this.transferInfo.toBoxNo = ''
      this.transferVisiable = true
    },
    handleOrderSelectionChange(val){
      this.transferInfo.boxOrderIdList = val.map(item => item.id);
    },
    checkboxSelect (row) {
      if (row.checkStatus == '0'){
        return true
      }
      return false
    },
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    orderDateRange () {
    },
    queryInfoClear () {
      this.queryInfo = {
        boxNo: this.queryInfo.boxNo,
        orderNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 999,
        pageNum: 1,
      }
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    async getOrderList () {
      const { data: res } = await this.$http.get("box/boxOrderlist", { params: this.queryInfo });
      this.orderList = res.data.list;
      this.total = res.data.total;
    },
    async getBoxInfo () {
      const { data: res } = await this.$http.get('box/getBoxInfo/' + this.queryInfo.boxNo);
      this.boxInfo = res.data;
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getUserList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getUserList();
    },

  },
  watch: {
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
  created () {
    this.queryInfo.boxNo = this.$route.query.boxNo;
    this.containerBatchNo = this.$route.query.containerBatchNo;
    this.getOrderList();
    this.getBoxInfo();

  },
};
</script>

<style lang="less" scoped>
.query-content {
  margin-top: 5px;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.box-order-list{
  /deep/.el-table-column--selection{
    text-align: center;
  }
}
</style>
